function Close(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={19}
      viewBox="0 0 20 19"
      {...props}
    >
      <g fill="#FFF" fillRule="evenodd">
        <path d="M.808 17.393L17.778.423l1.414 1.414-16.97 16.97z" />
        <path d="M2.222.423l16.97 16.97-1.414 1.414L.808 1.837z" />
      </g>
    </svg>
  );
}

export default Close;
